/** One run of a snippet's text; `match` where the search marked it with `[` `]`. */
export interface SnippetPart {
  readonly text: string;
  readonly match: boolean;
}

/**
 * Split a search snippet at its `[` `]` marks. The engines do not escape brackets in the
 * text, so a mark is only a `[` closed by the next `]` with no `[` between them and text
 * inside; any other bracket stays as text. The result is text only, never markup.
 */
export function snippetParts(snippet: string): readonly SnippetPart[] {
  const parts: SnippetPart[] = [];
  let plain = "";
  let position = 0;
  for (let open = snippet.indexOf("[", position); open !== -1; open = snippet.indexOf("[", position)) {
    const close = snippet.indexOf("]", open + 1);
    if (close === -1) break;
    const nextOpen = snippet.indexOf("[", open + 1);
    if (close === open + 1 || (nextOpen !== -1 && nextOpen < close)) {
      plain += snippet.slice(position, open + 1);
      position = open + 1;
      continue;
    }
    plain += snippet.slice(position, open);
    if (plain !== "") parts.push({ text: plain, match: false });
    plain = "";
    parts.push({ text: snippet.slice(open + 1, close), match: true });
    position = close + 1;
  }
  plain += snippet.slice(position);
  if (plain !== "") parts.push({ text: plain, match: false });
  return parts;
}
